
tagDirectve = (tagClassFilter) ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'util/tags/tag'
    scope:
        tag: '='
        remove: '&'
    link: (scope, element) ->
        element.addClass(tagClassFilter(scope.tag).join(' '))
        return

module.directive 'dybTag', tagDirectve
